import React from "react";
import { Box, CardBody, CardFooter, CardHeader, VStack } from "@chakra-ui/react";
import { SubmitBtn } from "../../atoms/button/SubmitBtn";
import { DarkShadowCard } from "../../molecules/card/DarkShadowCard";
import { CardHeading } from "../../molecules/card/CardHeading";
import { CiShop } from "react-icons/ci";


type RestaurantFormProps = {
  onSubmit: (data: any) => Promise<void>;
  isSubmitting: boolean;
  inputFields: {
    component: React.ComponentType<any>;
    props: Record<string, any>;
  }[];
  cardTitle: string;
}
export const RestaurantForm = ({onSubmit, isSubmitting, inputFields, cardTitle}: RestaurantFormProps) => {
  return (
    <Box m='auto' w={{base: '100%', md: '650px'}}>
      <form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit(e); // ✅ ここは props.onSubmit ではなく onSubmit だけでOK！
          }}
          encType="multipart/form-data"
      >
        <DarkShadowCard>
          <CardHeader>
            <CardHeading icon={<CiShop size="20px" />} heading={cardTitle}/>
          </CardHeader>
          <CardBody py={2}>
            <VStack spacing={4}>
              {inputFields.map(({ component: InputComponent, props }, index) => <InputComponent key={index} {...props} />)}
            </VStack>
          </CardBody>
          <CardFooter>
            <SubmitBtn type="submit" isLoading={isSubmitting}>登録</SubmitBtn>
          </CardFooter>
        </DarkShadowCard>
      </form>
    </Box>
  );
};